import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import InputBase from '@material-ui/core/InputBase';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import * as Routes from '~/router/routes';
import { history } from '~/router/history';
import { generatePath } from 'react-router';
import ResponsiveComponent from "@components/form/ResponsiveComponent";
import MenuOpenIcon from '@material-ui/icons/MenuOpen';
import { NotificationsContainer } from './components/notifications.container';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import {USER_CONTEXT_FAILURE} from '@components/auth/constants';
import {Link} from "react-router-dom";
import Avatar from "@material-ui/core/Avatar";
import {toast} from 'react-toastify'
import BadgeAvatar from "@components/common/badges/BadgeAvatar";

export class HeaderComponent extends React.Component {
    state = {
        menuOpened: false,
        anchorElm: null,
        error: false,
    };

    async componentDidMount() {
        let {user = {}, permissions = {}} = this.props.context;
        if (
            Object.keys(user).length === 0
            && Object.keys(permissions).length === 0
        ) {
            let response = await this.props.getUserContext();
            if (response.type === USER_CONTEXT_FAILURE) {
                this.setState({error: true});
            }
        } else {
            this.props.setInitialContext(this.props.context);
        }
    }

    handleMenu = event => {
        this.setState({
            anchorElm: event.currentTarget,
            menuOpened: !this.state.menuOpened
        });
    };

    handleMenuItem = path => {
        this.setState({menuOpened: false});
        history.push(generatePath(path));
    }

    render() {
        if (this.state.error) throw new Error('Context error');
        const {classes, context: {company, user}, isSocketConnected} = this.props;

        return (
            <div className={classes.root}>
                <AppBar position="static">
                    <Toolbar style={{display: 'flex', justifyContent: 'space-between'}}>
                        <div className={classes.menuSection}>
                            <ResponsiveComponent
                                xs={
                                    <IconButton
                                        edge="start"
                                        className={classes.menuButton}
                                        color="inherit"
                                        aria-label="open drawer"
                                        onClick={this.props.openSidebar}
                                    >
                                        <MenuIcon/>
                                    </IconButton>
                                }
                                md={<IconButton
                                    edge="start"
                                    className={classes.menuButton}
                                    color="inherit"
                                    aria-label="open drawer"
                                    style={{
                                        transform: `rotate(${this.props.isSidebarOpened ? '0' : '180'}deg)`,
                                    }}
                                    onClick={this.props.isSidebarOpened ? this.props.closeSidebar : this.props.openSidebar}
                                >
                                    <MenuOpenIcon/>
                                </IconButton>}
                            />
                            <Typography className={classes.title} variant="h6" noWrap>
                                BeClear CRM - {company.name}
                            </Typography>
                            <div className={classes.verticalLine}></div>
                            <div className={classes.search}>
                                <div className={classes.searchIcon}>
                                    <SearchIcon />
                                </div>
                                <InputBase
                                    placeholder="Найти…"
                                    classes={{
                                        root: classes.inputRoot,
                                        input: classes.inputInput,
                                    }}
                                    inputProps={{ 'aria-label': 'search' }}
                                    onFocus={() => toast['info']('Данный функционал скоро будет реализован. Приносим свои извинения за ожидание :)')}
                                    onKeyPress={(e) => {
                                        if (e.key === 'Enter') {
                                            toast['info']('Данный функционал скоро будет реализован. Приносим свои извинения за ожидание :)');
                                        }
                                    }}
                                />
                            </div>
                        </div>

                        <div className={classes.userSection}>
                            <div className={classes.language}>
                                <Typography variant={'body2'}>
                                    <span
                                        style={{color: '#c5cae9'}}
                                        onClick={() => toast['info']('Данный функционал скоро будет реализован. Приносим свои извинения за ожидание :)')}
                                    >Укр.</span>
                                    <span> | </span>
                                    <span
                                        onClick={() => toast['info']('Данный функционал скоро будет реализован. Приносим свои извинения за ожидание :)')}
                                    >Рус.</span>
                                </Typography>
                            </div>

                            <NotificationsContainer />

                            <div className={classes.tariffWrapper}>
                                <Typography noWrap variant={'body2'}>Тариф "{company.tariff}"</Typography>
                                <Typography noWrap variant={'body2'}>Осталось: {company.daysLeft < 0 ? 0 : company.daysLeft} дней</Typography>
                            </div>

                            <div className={classes.userMenu}>
                                <BadgeAvatar
                                  isSocketConnected={isSocketConnected}
                                >
                                    <Avatar
                                        alt={user.name}
                                        src={user.avatar}
                                        style={{cursor: 'pointer'}}
                                        onClick = {this.handleMenu}
                                    >
                                        {user.name?.split(' ').map(item => item[0]).join('')}
                                    </Avatar>
                                </BadgeAvatar>
                                <ArrowDropDownIcon
                                    style={{cursor: 'pointer'}}
                                    onClick={this.handleMenu}
                                />
                            </div>
                            <Menu
                                id="menu-appbar"
                                anchorEl={this.state.anchorElm}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={this.state.menuOpened}
                                onClose={({}) => this.setState({menuOpened: false})}
                            >
                                <MenuItem component={Link} to={Routes.PROFILE} onClick={() => this.handleMenuItem(Routes.PROFILE)}>Профиль</MenuItem>
                                {/*<MenuItem>Настройки</MenuItem>*/}
                                <MenuItem component={Link} to={Routes.LOGOUT} onClick={() => this.handleMenuItem(Routes.LOGOUT)}>Выйти</MenuItem>
                                {/*{isBrowser ? <SlackMessenger/> : null}*/}
                            </Menu>
                        </div>
                    </Toolbar>
                </AppBar>
            </div>
        );
    }
}
